import type { FlattenSimpleInterpolation } from 'styled-components';

import { css } from '../styled';

export function listReset(): FlattenSimpleInterpolation {
  return css`
    list-style: none;
    margin: 0;
    padding: 0;
  `;
}

export function buttonReset(): FlattenSimpleInterpolation {
  return css`
    border: none;
    padding: 0;
  `;
}
